import React, { useState, useEffect } from "react";
import "react-responsive-modal/styles.css";
import { Modal } from "react-responsive-modal";
import { GENDER_LIST } from "../../actionTypes/types";
import DatePicker from "react-date-picker";
import { globalLoader } from "../../actions/commonActions";
import InputComponent from "../_common/inputComponent";
import { validPostCodeFunc } from '../../_shared/commonFunction'
import { formatDate } from "../../i18n/dateLocale";
import ShortUniqueId from "short-unique-id";
import { useTranslation } from "react-i18next";
const uid = new ShortUniqueId({ length: 6, dictionary: `alphanum_upper` });

const AddUserModal = (props) => {
  const { t } = useTranslation();
  const [phone, setPhone] = useState("");
  const [uuid, setUuid] = useState("");
  const [oldUuid, setOldUuid] = useState("");
  const [gender, setGender] = useState("");
  const [phoneErr, setPhoneErr] = useState(false);
  const [postCodeErr, setPostCodeErr] = useState(false);
  const [validPostcodeVal, setValidPostcodeVal] = useState(false);

  const [birthDateErr, setBirthDateErr] = useState(false);
  const [genderErr, setGenderErr] = useState(false);
  const [dob, setDob] = useState(null);
  const [postalcode, setPostalcode] = useState("");

  useEffect(() => {
    setPropsToState(); // eslint-disable-next-line
  }, [props?.data]);


  const setPropsToState = () => {
    if(props?.data?.mobile) {
      setPhone(props?.data?.mobile);
    }
    if(props?.data?.uuid) {
      setUuid(props?.data?.uuid);
      setOldUuid(props?.data?.uuid);
    }
    if(props?.data?.gender) {
      setGender(props?.data?.gender);
    }
    if(props?.data?.postalCode) {
      handlePostalCode(props?.data?.postalCode?.toUpperCase());
    }
    if(props?.data?.dateOfBirth) {
      setDob(props?.data?.dateOfBirth);
    }
  };

  const handleValidation = () => {
    let flag = true;
    if (!phone) {
      setPhoneErr(true);
      flag = false;
    }
    if (phone?.length < 10) {
      flag = false;
    }
    if (!postalcode) {
      setPostCodeErr(true);
      flag = false;
    }

    if (!dob) {
      setBirthDateErr("You have not selected your date of birth");
      flag = false;
    }
    if (!gender) {
      setGenderErr(true);
      flag = false;
    }
    if (!validPostcodeVal) {
      flag = false;
    }
    return flag;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (await handleValidation()) {
      globalLoader(true);
      let obj = {
        // postalCode: postalcode.replace(/\s+/g, ""),
        postalCode: postalcode,
        mobile: phone,
        dateOfBirth: dob,
        gender: gender,
        uuid,
      };
      props.closeModal(obj);
    }
  };

  const handlePostalCode = async (ev) => {
    let data = ev;
    if (data.length < 8) {
      //   if (data.length > 3) {
      //     data = data.replace(/\s+/g, "");
      //     data = data.substr(0, 3) + " " + data.substr(3, 7);
      //   }
      let value = data.split(" ").join("");



      setPostalcode(value);
      setValidPostcodeVal(await validPostCodeFunc(value))
    }
  };

  const handlePhoneInput = (evt) => {
    const regex = /^[0-9\b]+$/;
    const value = evt;
    if (value === "" || regex.test(value)) {
      setPhone(value);
    } else if (!phone) {
      // setPhone("");
    }
  };

  return (
    <Modal
      open={props.open}
      onClose={() => props.closeModal()}
      center
      classNames={{ modal: "admin-modal" }}
    >
      <div>
        <p className="admin-banner">{t(props?.edit ? "admin.addUser.editTitle" : "admin.addUser.addTitle")}</p>
      </div>
      <form onSubmit={handleSubmit} className="form-own pt-3 px-3">
        <div className="row">
          <div className="col-6 px-2">
            <div className="form-own-group">
              <InputComponent
                placeholder={t("admin.addUser.mobilePlaceholder")}
                label={
                  <>
                    {t("admin.addUser.mobileLabel")} <span className="color-red">*</span>
                  </>
                }
                type="text"
                name="phone"
                theme="white"
                disabled={props?.edit}
                value={phone}
                handleCallback={(val) => {
                  handlePhoneInput(val);
                }}
                maxLength="11"
              />
              <div className="error-text">
                {!phone && phoneErr && <span>{t("admin.addUser.mobileRequired")}</span>}
                {phone && phone.length < 10 && (
                  <span>{t("admin.addUser.mobileMustHave10Digits")}</span>
                )}
              </div>
            </div>
          </div>
          <div className="col-6 px-2">
            <div className="form-own-group">
              <InputComponent
                placeholder={t("admin.addUser.postcodePlaceholder")}
                label={
                  <>
                    {t("admin.addUser.postcodeLabel")} <span className="color-red">*</span>
                  </>
                }
                type="text"
                name="postCode"
                inputFor="text"
                theme="white"
                value={postalcode}
                disabled={props?.edit}
                handleCallback={(val) => handlePostalCode(val)}
                maxLength="7"
                // className="text-uppercase"
                capsValue={true}
              />
              <div className="error-text">
                {!postalcode && postCodeErr && (
                  <span>{t("admin.addUser.postcodeRequired")}</span>
                )}
                {postalcode && !validPostcodeVal && (
                  <span>{t("admin.addUser.invalidPostcode")} </span>
                )}
              </div>
            </div>
          </div>
          <div className="col-6 px-2">
            <div className="form-own-group">
              {!props?.edit && <>
                <label
                  className="datepicker-label primary-color"
                  htmlFor="birthDate"
                >
                  {t("admin.addUser.dobLabel")} <span className="color-red">*</span>
                </label>
                <div className="own-datepicker">
                  <DatePicker
                    onChange={(evt) => {
                      setDob(evt);
                      setBirthDateErr("");
                    }}
                    value={dob}
                    disableCalendar={props?.edit}
                    maxDate={new Date()}
                    format={"dd/MM/yyy"}
                  />
                </div>
                <div className="error-text">
                  {!dob && birthDateErr && <span>{t("admin.addUser.dobRequired")}</span>}
                </div>
              </>}
              {props?.edit && <>
              <InputComponent
                placeholder={t("admin.addUser.dobPlaceholder")}
                label={
                  <>
                    {t("admin.addUser.dobLabel")} <span className="color-red">*</span>
                  </>
                }
                type="text"
                name="dateOfBirth"
                inputFor="text"
                theme="white"
                value={formatDate(new Date(props?.data?.dateOfBirth))}
                disabled={props?.edit}
                handleCallback={() => {}}
              />
              </>}
            </div>
          </div>
          <div className="col-6 px-2">
            <div className="form-own-group">
              <InputComponent
                placeholder={t("admin.addUser.uuidPlaceholder")}
                label={
                  <>
                    {t("admin.addUser.uuidLabel")}
                  </>
                }
                type="text"
                name="uuid"
                theme="white"
                disabled={!props?.edit}
                value={uuid}
                handleCallback={(val) => {
                  setUuid(val);
                }}
              />
              {uuid != oldUuid && uuid && oldUuid && <span>{t("admin.addUser.currentUuid")} {oldUuid}</span>}
              <br />
              <span
              onClick={() => setUuid(uid?.rnd(6)?.toUpperCase())}
              className="btn btn-own-admin primary-btn btn-sm-own table-action" style={{marginTop: "10px"}}>{t("admin.addUser.autoGenerateUuid")}</span>
            </div>
          </div>
          <div className="col-12 px-2">
            <div className="form-own-group">
              <label className="form-own-label" htmlFor="gender">
                {t("admin.addUser.genderLabel")} <span className="color-red">*</span>
              </label>
              <div className="radio-wrapper">
                {GENDER_LIST.map((i) => {
                  return (
                    <div key={i.id} className="radio" id="gender">
                      <input
                        id={i.id}
                        className="hidden radio-label"
                        type="radio"
                        value={i.value}
                        disabled={props?.edit}
                        name="gender"
                        checked={gender === i.value}
                        onChange={(evt) => setGender(evt.target.value)}
                      />
                      <label className="btn-label" htmlFor={i.id}>
                        <p>{t(i.text)}</p>
                      </label>
                    </div>
                  );
                })}
              </div>
              <div className="error-text">
                {!gender && genderErr && <span>{t("admin.addUser.genderRequired")}</span>}
              </div>
            </div>
          </div>
        </div>
        <div className="admin-btn">
          <button
            onClick={() => props.closeModal()}
            className="btn secondary-btn mr-2"
            type="button"
          >
            {t("common.back")}
          </button>
          <button type="submit" className="btn primary-btn ml-2">
            {t("common.submit")}
          </button>
        </div>
      </form>
    </Modal>
  );
};

export default AddUserModal;
